import React, { useEffect, useState } from 'react';
import { SiTicktick } from "react-icons/si";
import { FaCircleCheck } from "react-icons/fa6";

interface ValidateProps {
    confPassword: string;
    password: string;
    setIsStrongPassword: React.Dispatch<React.SetStateAction<boolean>>;
}

const PassValidateView: React.FC<ValidateProps> = ({ password, confPassword, setIsStrongPassword }) => {
    const [validationStatus, setValidationStatus] = useState({
        length: false,
        lowercase: false,
        uppercase: false,
        digit: false,
        specialChar: false,
        samepass: false,
    });

    const passwordMessages: { [key: string]: string } = {
        length: "Password must be at least 8 characters long.",
        lowercase: "Password must contain at least one lowercase letter.",
        uppercase: "Password must contain at least one uppercase letter.",
        digit: "Password must contain at least one digit.",
        specialChar: "Password must contain at least one special character.",
        samepass: "Password and confirm password do not match.",
    };

    useEffect(() => {
        function validatePassword(password: string, confPassword: string) {
            const newValidationStatus = {
                length: password.length >= 8,
                lowercase: /[a-z]/.test(password),
                uppercase: /[A-Z]/.test(password),
                digit: /\d/.test(password),
                specialChar: /[^a-zA-Z0-9]/.test(password),
                samepass: password.length > 0 && password === confPassword,
            };
            setValidationStatus(newValidationStatus);

            const isStrong = Object.values(newValidationStatus).every(status => status === true);
            setIsStrongPassword(isStrong);
        }

        validatePassword(password, confPassword);
    }, [password, confPassword]);

    return (
        <div className="p-2">
            <div className="text-[14px] flex items-start gap-2">
                {validationStatus.length ? <SiTicktick size={16} color="green" /> : <SiTicktick size={16} color="red" />}
                <span style={{ color: validationStatus.length ? 'green' : 'red' }}>{passwordMessages.length}</span>
            </div>
            <div className="text-[14px] flex items-start gap-2">
                {validationStatus.lowercase ? <SiTicktick size={16} color="green" /> : <SiTicktick size={16} color="red" />}
                <span style={{ color: validationStatus.lowercase ? 'green' : 'red' }}>{passwordMessages.lowercase}</span>
            </div>
            <div className="text-[14px] flex items-start gap-2">
                {validationStatus.uppercase ? <SiTicktick size={16} color="green" /> : <SiTicktick size={16} color="red" />}
                <span style={{ color: validationStatus.uppercase ? 'green' : 'red' }}>{passwordMessages.uppercase}</span>
            </div>
            <div className="text-[14px] flex items-start gap-2">
                {validationStatus.digit ? <SiTicktick size={16} color="green" /> : <SiTicktick size={16} color="red" />}
                <span style={{ color: validationStatus.digit ? 'green' : 'red' }}>{passwordMessages.digit}</span>
            </div>
            <div className="text-[14px] flex items-start gap-2">
                {validationStatus.specialChar ? <SiTicktick size={16} color="green" /> : <SiTicktick size={16} color="red" />}
                <span style={{ color: validationStatus.specialChar ? 'green' : 'red' }}>{passwordMessages.specialChar}</span>
            </div>
            <div className="text-[14px] flex items-start gap-2">
                {validationStatus.samepass ? <SiTicktick size={16} color="green" /> : <SiTicktick size={16} color="red" />}
                <span style={{ color: validationStatus.samepass ? 'green' : 'red' }}>{passwordMessages.samepass}</span>
            </div>
        </div>
    );
};

export default PassValidateView;
